<template>
  <div class="my">
    <div class="head">
      <div class="icon">
        <img src="@static/images/user.jpg" alt="">
        <p>{{ userInfo.username || '微信用户' }}</p>
      </div>
      <!-- <div class="edit">
        <van-icon name="edit" size="24px" />
        完善信息
      </div> -->
      <div class="edit" @click="loginOut()">
        退出登录
      </div>
    </div>
    <div class="part" @click="$router.push('/app/policysList')">
      <van-cell title="我的收入" is-link value="查看详情" size="large" title-style="font-weight: 600" border />
      <div class="total">
        <div>
          <p>{{ stat.zsr || 0 }}</p>
          <p>总收入</p>
        </div>
        <div>
          <p>{{ stat.wjsSr || 0 }}</p>
          <p>未结算</p>
        </div>
        <div>
          <p>{{ stat.ktxSr || 0 }}</p>
          <p>可提现</p>
        </div>
      </div>
    </div>
    <div class="part" @click="$router.push('/app/bxAgentList')">
      <van-cell title="我的推广" is-link value="点击查看" size="large" title-style="font-weight: 600" />
      <div class="total">
        <div>
          <p>{{ stat.tg1 || 0 }}</p>
          <p>推广1</p>
        </div>
        <div>
          <p>{{ stat.tg2 || 0 }}</p>
          <p>推广2</p>
        </div>
      </div>
    </div>
    <van-cell title="我的客户" is-link value="查看详情" size="large" title-style="font-weight: 600" @click="$router.push('/app/customerList')" />
    <div class="part">
      <van-cell title="推广跟进" is-link value="去追踪" size="large" title-style="font-weight: 600" @click="$router.push('/app/followUp')" />
      <div class="total" style="background-color: #fce7e2">
        <div>
          <p>{{ stat.dgj || 0 }}</p>
          <p>待跟进(件)</p>
        </div>
        <div>
          <p>{{ stat.ycq || 0 }}</p>
          <p>已超期(件)</p>
        </div>
      </div>
    </div>
    <!-- <van-cell title="账户设置" is-link icon="setting-o" size="large" /> -->
    <bottomNav :active="4"></bottomNav>
  </div>
</template>

<script>
import bottomNav from "@/components/bottomNav.vue";
export default {
  components: {
    bottomNav
  },
  data() {
    return {
      userInfo: {},
      stat: {}
    };
  },
  computed: {},
  created(){
    this.$http({
      type: "GET",
      url: "/api/getUserDetail",
      data: {},
    })
    .then(res => {
      this.userInfo = res.data || {}
    })
    this.getStat();
  },
  methods: {
    getStat(){
      this.$http({
        type: "GET",
        url: "/api/stat",
        data: {},
      })
        .then(res => {
          this.stat = res.data
        })
    },
    loginOut(){
      localStorage.removeItem('h5_token');
      this.$router.replace({
        path: "/app/login",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.my{
  .part{
    .total{
      display: flex;
      justify-content: space-around;
      padding: 20px 0;
      p{
        text-align: center;
        &:nth-of-type(1){
          color: #fb5b37;
          font-size: 36px;
          font-weight: 600;
        }
        &:nth-of-type(2){
          color: #bebebe;
          font-size: 30px;
        }
      }
    }
    &:nth-of-type(2), &:nth-of-type(3){
      border-bottom: 10px solid #ececec;
    }
  }
  .van-cell{
    border-bottom: 1px solid #ececec;
    &:nth-of-type(4){
      border-bottom: 10px solid #ececec;
    }
    .van-cell__title{
      font-size: 40px;
    }
    .van-cell__value{
      font-size: 30px;
    }
  }
}
.head{
  background: url("~static/images/bg-3.png") no-repeat;
  background-size: 100%;
  height: 350px;
  position: relative;
  .icon{
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 30px;
    img{
      width: 100px;
      height: 100px;
      margin-right: 30px;
      border-radius: 50%;
      border: 8px solid rgba($color: #fff, $alpha: 0.2);
    }
    p{
      font-size: 40px;
      color: #fff;
    }
  }
  .edit{
    position: absolute;
    top: 30px;
    right: 30px;
    color: #fff;
    font-size: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
